import { useEffect } from 'react';
import { useAuthStore } from '@/store/authStore';
import { useChatStore } from '@/store/chatStore';
import {
  connectChatRealtime,
  disconnectChatRealtime,
} from '@/lib/chat/chatRealtime';

/**
 * Keeps Socket.io + global chat listeners alive for the whole member session.
 * Mount once at the app shell — not tied to the Chat tab.
 */
export function ChatRealtimeBridge() {
  const sessionReady = useAuthStore((s) => s.sessionReady);
  const userId = useAuthStore((s) => s.user?.id);
  const accountType = useAuthStore((s) => s.user?.accountType);

  useEffect(() => {
    if (!sessionReady) return;

    const isMember = accountType === 'member' && Boolean(userId);
    if (!isMember || !userId) {
      disconnectChatRealtime();
      return;
    }

    useChatStore.setState({ myUserId: userId });
    if (import.meta.env.DEV) {
      console.info('[ChatRealtimeBridge] connect', userId);
    }
    connectChatRealtime(userId, () => useChatStore.getState());
    // Pending-request/friends/inbox data is loaded by useChat's initialize()
    // when /member/chat is actually opened — not eagerly on every page.
  }, [sessionReady, userId, accountType]);

  return null;
}
